export const BEHAVIORS = [
  {
    title: '全部互动',
    value: 'ALL',
    key: 'ALL',
    children: [
      {
        title: '已关注用户',
        value: 'FOLLOWED_USER',
        key: 'FOLLOWED_USER'
      },
      {
        title: '视频互动',
        value: 'VIDEO',
        key: 'VIDEO',
        children: [
          {
            title: '已评论用户',
            value: 'COMMENTED_USER',
            key: 'COMMENTED_USER'
          },
          {
            title: '已点赞用户',
            value: 'LIKED_USER',
            key: 'LIKED_USER'
          },
          {
            title: '已分享用户',
            value: 'SHARED_USER',
            key: 'SHARED_USER'
          }
        ]
      },
      {
        title: '直播互动',
        value: 'LIVE',
        key: 'LIVE',
        children: [
          {
            title: '直播观看',
            value: 'LIVE_WATCH',
            key: 'LIVE_WATCH'
          },
          {
            title: '直播有效观看',
            value: 'LIVE_EFFECTIVE_WATCH',
            key: 'LIVE_EFFECTIVE_WATCH'
          },
          {
            title: '直播评论',
            value: 'LIVE_COMMENT',
            key: 'LIVE_COMMENT'
          },
          {
            title: '直播打赏',
            value: 'LIVE_EXCEPTIONAL',
            key: 'LIVE_EXCEPTIONAL'
          },
          {
            title: '直播商品点击',
            value: 'LIVE_GOODS_CLICK',
            key: 'LIVE_GOODS_CLICK'
          },
          {
            title: '直播商品下单',
            value: 'LIVE_GOODS_ORDER',
            key: 'LIVE_GOODS_ORDER'
          }
        ]
      },
      {
        title: '商品互动',
        value: 'GOODS',
        key: 'GOODS',
        children: [
          {
            title: '购物车点击',
            value: 'GOODS_CARTS_CLICK',
            key: 'GOODS_CARTS_CLICK'
          },
          {
            title: '购物车下单',
            value: 'GOODS_CARTS_ORDER',
            key: 'GOODS_CARTS_ORDER'
          }
        ]
      }
    ]
  }
]

export const DAYS = [
  {
    key: 'FIFTEEN_DAYS',
    value: '近15天'
  },
  {
    key: 'THIRTY_DAYS',
    value: '近30天'
  },
  {
    key: 'SIXTY_DAYS',
    value: '近60天'
  }
]
